<template>
  <div class="wrapper main-container">
    <h1 style="font-weight: bold">{{ detail.title }}</h1>
    <div class="timeBox">{{ detail.sendTime | filterTime("YYYY-MM-DD") }}</div>
    <div style="padding-left: 20px" v-if="detail.msgType == 1">
      <span class="name"> 产品名称： </span>
      <span class="link" v-for="item in detail.productList" :key="item.productCode" @click="togglePage(item.productName)">{{
        item.productName
      }}</span>
      <span style="margin-left: 25px">上架时间：{{ detail.releaseTime }}</span>
    </div>
    <div class="time">{{ detail.updateTime }}</div>
    <div class="content" v-html="detail.content"></div>
  </div>
</template>

<script>
import { chatMangeDetail, chatPlatMangeDetail } from "@/api/httpList";
export default {
  components: {},
  props: {},
  data() {
    return {
      detail: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    togglePage(name) {
      if (this.detail.hasProduct) {
        sessionStorage.setItem("productName", name);
        // sessionStorage.setItem("productCode", this.detail.productCode);
        if (this.userType == 1) {
          this.$router.push("/operate/productManage/product");
        } else {
          this.$router.push("/productResource/product/index");
        }
      } else {
        this.$Message.warning("商户下没有对应产品");
      }
    },
    back() {
      const fullPath = this.$route.fullPath;
      window.parent.postMessage({
        removePageTag: fullPath,
        appMessage: true,
      }, "*");
      this.$router.go(-1);
    }
  },
  
  mounted() {
    document.title = "公告详情-保险中介云";
    this.userType = JSON.parse(localStorage.getItem("userInfo")).userType;
    chatMangeDetail(this.$route.query.id).then((res) => {
      this.detail = res.data;
    });
  },
};
</script>
<style lang="scss" scoped>
.link {
  color: #236dff;
  text-decoration: underline;
  cursor: pointer;
  margin-right: 5px;
}
.main-container {
  padding: 20px;
  width: 1000px;
  margin: auto;
  .name {
    font-weight: bold;
    color: #333;
    &:hover {
      cursor: pointer;
    }
  }
  h1 {
    font-size: 18px;
    color: #333;
    text-align: center;
  }
  .timeBox {
    font-size: 14px;
    color: #8a9095;
    text-align: center;
    margin-top: 10px;
  }
  .time {
    font-size: 14px;
    color: #8a9095;
    text-align: center;
  }
  .content {
    padding: 20px;
  }
}
</style>
